"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.editableTable = void 0;
var React = __importStar(require("react"));
var components_1 = require("../../components");
function editableTable() {
    var _this = this;
    var EditableContext = React.createContext({});
    var EditableRow = function (_a) {
        var index = _a.index, props = __rest(_a, ["index"]);
        var _b = __read(components_1.Form.useForm(), 1), form = _b[0];
        return (React.createElement(components_1.Form, { form: form, component: false },
            React.createElement(EditableContext.Provider, { value: form },
                React.createElement("tr", __assign({}, props)))));
    };
    var EditableCell = function (props) {
        var title = props.title, editable = props.editable, children = props.children, dataIndex = props.dataIndex, record = props.record, _a = props.className, className = _a === void 0 ? null : _a, _b = props.validationRules, validationRules = _b === void 0 ? null : _b, handleSave = props.handleSave, handleError = props.handleError, restProps = __rest(props, ["title", "editable", "children", "dataIndex", "record", "className", "validationRules", "handleSave", "handleError"]);
        var _c = __read(React.useState(false), 2), editing = _c[0], setEditing = _c[1];
        var inputRef = React.useRef();
        var form = React.useContext(EditableContext);
        React.useEffect(function () {
            if (editing && inputRef.current) {
                inputRef.current.focus();
            }
        }, [editing]);
        var onKeyPress = function (event) {
            if (event.key === "Enter") {
                toggleEdit();
            }
        };
        var toggleEdit = function () {
            var _a;
            setEditing(!editing);
            form.setFieldsValue((_a = {}, _a[dataIndex] = record[dataIndex], _a));
        };
        var save = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var values, errInfo_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, form.validateFields()];
                    case 1:
                        values = _a.sent();
                        toggleEdit();
                        handleSave(__assign(__assign({}, record), values), event);
                        return [3 /*break*/, 3];
                    case 2:
                        errInfo_1 = _a.sent();
                        if (handleError && typeof handleError === "function") {
                            handleError(errInfo_1, event);
                        }
                        else {
                            console.error("Save failed:", errInfo_1);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var childNode = children;
        if (editable) {
            if (editing) {
                childNode = (React.createElement(components_1.Form.Item, { name: dataIndex, rules: validationRules ? validationRules : [{ required: true, message: title + " is required." }] },
                    React.createElement(components_1.Input, { ref: inputRef, onBlur: save, onPressEnter: save })));
            }
            else {
                childNode = (
                // eslint-disable-next-line jsx-a11y/interactive-supports-focus
                React.createElement("div", { className: "editable-cell-value-wrap", role: "gridcell", onKeyPress: onKeyPress, onClick: toggleEdit }, children));
            }
        }
        var newClassName = (editable ? "editable-row " : "") + (className ? className : "");
        return (React.createElement("td", __assign({ className: newClassName }, restProps), childNode));
    };
    return {
        EditableRow: EditableRow,
        EditableCell: EditableCell,
    };
}
exports.editableTable = editableTable;
//# sourceMappingURL=editableTable.js.map